module.exports = __webpack_public_path__ + "static/v2Res1-f5b013859fff7d6d18bead8bc55648b0.png";